/**
 * Created by Bart Decorte
 * Date: 13/09/2021
 * Time: 15:51
 */
import Dropzone from './Dropzone';
import UploadPreviewList from './UploadPreviewList';
import MultiChunkedUpload from './MultiChunkedUpload';

export default class MultiDropzone extends Dropzone {
  constructor(rootEl, params = {}) {
    super(rootEl, params);
    this.preview = new UploadPreviewList(
      this.uploadsEl(),
      {
        type: this.dataType(),
        offset: this.indexOffset(),
      },
    );
    this.upload = new MultiChunkedUpload();
    this.bindUploadListeners();
    this.bindPreviewListeners();
  }

  lUploadCanceled() {
    // Do nothing
  }

  lPreviewCanceled({ preview }) {
    this.fileInfo.removeFileInfo(preview.index);
    // If lt 0, this a previously uploaded file, actual "old input", not handled by the current upload instance
    if (preview.index - this.indexOffset() >= 0) {
      this.upload.cancelUploadAtIndex(preview.index - this.indexOffset());
    }
  }

  lUploadProgressed({ progress, upload: { index, progress: uploadProgress } }) {
    this.preview.setProgress(index + this.indexOffset(), uploadProgress);
  }

  lUploadSucceeded({ result }) {
    if (!this.upload.active) {
      this.fileInfo.renderFilesMeta(result);
      this.emitSuccess();
    }
  }

  push(files) {
    this.upload.push(files);
    this.preview.push(files);
  }

  restore() {
    this.preview.clear();
  }

  showProgress(doShow) {
     // total progress is N/A, we're showing it on a per-upload basis
  }

  setProgress(decimal) {

  }

  setState(state) {

  }

  emitChange() {
    this.emit('change', { files: this.upload.files });
  }

  emitSuccess() {
    this.emit('success', this.upload.result());
  }

  uploadsEl() {
    return this.rootEl.querySelector('.js-uploads');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/MultiDropzone.js